// store/watches.js
const state = {
    otherWatches: [],
    watchesSold: [],
  };
  
  const getters = {
    getOtherWatches: (state) => state.otherWatches,
    getWatchesSold: (state) => state.watchesSold,
  };
  
  const mutations = {
    SET_OTHER_WATCHES(state, watches) {
      state.otherWatches = watches;
    },
    SET_WATCHES_SOLD(state, watches) {
      state.watchesSold = watches;
    },
    shuffleOtherWatches(state) {
      // Shuffle the 'otherWatches' array in place using the Fisher-Yates algorithm
      for (let i = state.otherWatches.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [state.otherWatches[i], state.otherWatches[j]] = [state.otherWatches[j], state.otherWatches[i]];
      }
    },
  };
  
  const actions = {
    async fetchOtherWatches({ commit }, address) {
      try {
        const response = await axios.get(address ? address : "/api/otherwatches");
        commit("SET_OTHER_WATCHES", response.data.data);
        commit("shuffleOtherWatches"); 
      } catch (error) {
        console.error(error);
      }
    },
    async fetchWatchesSold({ commit }, address) {
      try {
        const response = await axios.get(address ? address : "/api/otherwatchessold");
        commit("SET_WATCHES_SOLD", response.data.data);
      } catch (error) {
        console.error(error);
      }
    },
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  };
  